import { getItemFromCollection } from "directus/src/operations";

export async function fetchCaseStudyDataforForm({ casestudyId, fields }) {
    try {
        const query = {
            fields,
        };

        const response = await getItemFromCollection("case_studies", casestudyId, query);
        return response;
    } catch (error) {
        console.error(error);

        throw error;
    }
}